module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("THANKS FIRST")]), _vm._v(" and foremost to Dan Cullinan, who put up with ten million medical questions and was the only reason I was able to say, “Yes, I can do a medical trilogy.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Thank you to Tracy Cheuk and to the commenters on the Formosa forums, who kindly helped me make Hong-Wei more accurate and gave me insight into his life.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Thank you to Anna Cullinan and her mad mapmaking skills, which not only made Copper Point feel more real, but kept me from sending people in ten different directions.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Thank you to Elizabeth North for helping me dream up Copper Point and giving it a home at Dreamspinner Press.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Thank you to my patrons who kept me company as I drafted this work, who peeked at early drafts, and as always gave me the life and love I needed to keep going. Thank you especially to Rosie M, Pamela Bartual, Marie, and Sarah Plunkett.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Thank you to my readers, whether you have just found me or have been along for the ride for all ten years. Let’s make stories for thirty more.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6344eac3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0004.vue
// module id = 66
// module chunks = 0